import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
// import storageSession from 'reduxjs-toolkit-persist/lib/storage/session';
import applicantDetailsReducer from './reducers/applicant-details';
import featureFlagsReducer from './reducers/feature-flags';
import paymentReducer from './reducers/payment';
import planSummaryReducer from './reducers/plan-summary';
import assessmentReducer from './reducers/question-answer';
import uiStateReducer from './reducers/ui-state';

export const store = configureStore({
  reducer: {
    payment: paymentReducer,
    applicantDetails: applicantDetailsReducer,
    planSummary: planSummaryReducer,
    assessment: assessmentReducer,
    uiState: uiStateReducer,
    featureFlags: featureFlagsReducer,
  },
  devTools: process.env.NODE_ENV === 'development',
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
